// src/components/BookAbout.jsx
import { Users, MapPin, Smile, ShieldCheck } from "lucide-react";

const stats = [
    {
        icon: <Users size={32} />,
        number: "20+",
        label: "Product Categories",
        color: "text-yellow-400",
    },
    {
        icon: <MapPin size={32} />,
        number: "5+",
        label: "Cities Delivered",
        color: "text-blue-400",
    },
    {
        icon: <Smile size={32} />,
        number: "5,000+",
        label: "Happy Customers",
        color: "text-green-400",
    },
    {
        icon: <ShieldCheck size={32} />,
        number: "12",
        label: "Months Warranty",
        color: "text-pink-400",
    },
];

const BookAbout = () => {
    return (
        <section
            id="about"
            className="min-h-screen bg-gray-900 text-white py-20 px-4"
        >
            <div className="max-w-6xl mx-auto text-center mb-12">
                <h2 className="text-3xl text-yellow-400 font-bold mb-6">
                    About Us
                </h2>
                <p className="text-lg max-w-2xl mx-auto">
                    Book online anytime across Delhi-NCR. Affordable, upfront pricing with no hidden charges. We provide doorstep service of high-quality parts with clear warranty terms.
                </p>
            </div>

            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-start px-4">
                {/* Left side - summary card */}
                <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-6 shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-yellow-500/20 hover:border-yellow-400">
                    <p className="text-lg">
                        No time windows — book when you want. We bring you original parts with smooth doorstep delivery. Transparent prices, clear categories, and reliable warranty coverage make your experience hassle-free.
                    </p>
                    <ul className="list-disc list-inside text-sm text-gray-300 space-y-2 mt-4">
                        <li>Doorstep delivery across Delhi-NCR</li>
                        <li>Easy online booking anytime</li>
                        <li>Warranty-backed parts</li>
                        <li>Affordable, upfront pricing</li>
                        <li>Flexible scheduling & fast delivery</li>
                        <li>No hidden fees or extra charges</li>
                    </ul>
                </div>

                {/* Right side: Stats grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {stats.map((item, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center justify-center bg-white/5 backdrop-blur-md rounded-xl p-6 shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-yellow-500/20 border border-white/10 hover:border-yellow-400"
                        >
                            <div className="mb-2 text-white">{item.icon}</div>
                            <div className={`text-2xl font-bold ${item.color}`}>
                                {item.number}
                            </div>
                            <div className="text-sm text-gray-300 mt-1">{item.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BookAbout;
